import React, { useEffect, useState } from 'react';
import s from './MainComponent.module.scss';
import { Interface } from '../../mainComponents/Interface/Interface';
import { ModalState } from '../../mainComponents/modals/ModalState/ModalState';
import { PlayCanvasPlayer } from '../../components/PlayCanvasPlayer/PlayCanvasPlayer';
import { useStoreSelector } from '../..';
import { getConfigInfo } from '../../store/selectors/selectors';

export const MainComponent = React.memo(({ ...props }) => {
  const { assetID }: any = props;
  const [checkLoadConfig, setCheckLoadConfig] = useState(false);
  const configInfo = useStoreSelector(getConfigInfo);
  
  useEffect(() => {
    if (configInfo.isShortId) {
      setCheckLoadConfig(configInfo.isShortId);
    }
  }, [configInfo.isShortId]);

  return (
    <div className={`${s.main_container} ${s.wrapper}`}>
     
      <PlayCanvasPlayer />

 <Interface />

      <ModalState />
    </div>
  );
});
